import React from 'react';
import Select from 'react-select';
import * as Const from '../../utils/Const';

interface DropdownProps {
  label: string;
  data: { key: string; value: string }[];
  selected: string;
  onChange: (selected: string) => void;
  disabled: boolean;
  styleOption?: React.CSSProperties;
  selectedKey?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  label,
  data,
  selected,
  onChange,
  disabled,
  styleOption,
  selectedKey,
}) => {
  const safeData = data || [];

  return (
    <label className="flex items-center">
      <span className="text-base font-bold">{label}：</span>
      {/* <select
        value={selected}
        key={selectedKey}
        onChange={(e) => {
          const selectedKey = e.target.value;
          const selectedValue = safeData.find((item) => item.key === selectedKey);
          // 必要に応じてkeyも渡す
          onChange(selectedValue?.value ?? '');
          console.log(selectedKey);
          console.log(selectedValue);
          console.log(selectedValue?.value);
        }}
        disabled={disabled}
        className={`md:flex rounded-md gap-4 p-2 mb-1`}
        style={{
          borderWidth: '1px',
          borderColor: `${Const.SearchItemBorderColor}`,
          backgroundColor: `${Const.SearchItemColor}`,
          ...styleOption,
        }}
      >
        <option value="" disabled>
          {label}
          {Const.LabelDropdownMessage}
        </option>
        {safeData.map((item) => (
          <option key={item.key} value={item.key}>
            {item.value}
          </option>
        ))}
      </select> */}
      <Select
        options={safeData.map((item) => ({
          key: item.key,
          value: item.value,
          label: item.value,
        }))}
        value={
          safeData
            .map((item) => ({
              value: item.value,
              label: item.value,
            }))
            .find((option) => option.value === selected) || null
        }
        key={selected || ''}
        onChange={(option) => {
          if (option) {
            onChange(option.value);
          } else {
            onChange('');
          }
        }}
        isDisabled={disabled}
        className={`md:flex rounded-md gap-4 p-2 mb-1`}
        styles={{
          control: (provided) => ({
            ...provided,
            borderWidth: '1px',
            borderColor: `${Const.SearchItemBorderColor}`,
            backgroundColor: `${Const.SearchItemColor}`,
            ...styleOption,
          }),
        }}
        placeholder={`${label}${Const.LabelDropdownMessage}`}
      />
    </label>
  );
};

export { Dropdown };
